import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

// Services where NO GST - user pays exact amount (checked FIRST - highest priority)
const NO_GST_TYPES = ['RECHARGE', 'MOBILE RECHARGE', 'ELECTRICITY', 'FASTAG', 'DTH', 'GAS CYLINDER', 'GAS', 'METRO', 'METRO CARD', 'POSTPAID', 'PREPAID'];
// Services where GST is applicable (18%)
const GST_APPLICABLE_TYPES = ['HOTEL', 'FLIGHT', 'YATRA', 'POOJA', 'MILAN SATHI', 'PREMIUM', 'WALLET_RECHARGE', 'WALLET TOPUP'];

const isGSTApplicable = (billType) => {
    if (!billType) return false;
    const type = billType.toUpperCase().trim();
    // Check NO GST types FIRST (priority) - any recharge/utility service = no GST
    if (NO_GST_TYPES.some(t => type.includes(t))) return false;
    // Then check if GST applicable
    return GST_APPLICABLE_TYPES.some(t => type.includes(t));
};

const TransactionDetailsById = () => {
    const [data, setData] = useState()
    const token = localStorage.getItem('token');
    const query = useQuery();
    const transactionid = query.get('transactionid');
    const invoiceRef = useRef(null);

    const getTransactionHisById = async () => {
        try {
            const getResponse = await axios.get(`https://api.bharatdarshan.app/api/admin/payment/get-transaction-history-by-id?paymentHistoryId=${transactionid}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
            setData(getResponse?.data?.data)
        } catch (error) {
            console.log({ error });
        }
    }

    useEffect(() => {
        getTransactionHisById()
    }, [transactionid])

    const handleRefund = async () => {
        const promt = prompt('Are you sure you want to proceed with refund? Type YES to confirm')
        if (promt && promt.toUpperCase() === 'YES') {
            try {
                const response = await axios.post('https://api.bharatdarshan.app/api/admin/payment/refund-proceed',
                    {
                        amount: data?.amount,
                        receipt: data?.transactionalData?.razorpay_order_id,
                        notes: { "notes_key_1": "Refund Summary" },
                        payment_id: data?.transactionalData?.razorpay_payment_id,
                        trans_id: transactionid
                    },
                    {
                        headers: { Authorization: `Bearer ${token}` }
                    }
                )
                alert('Refund initiated successfully!')
                getTransactionHisById()
            } catch (error) {
                alert('Refund failed!')
                console.log({ error });
            }
        }
    }

    const handlePrintInvoice = () => {
        const printContent = invoiceRef.current;
        const win = window.open('', '', 'width=900,height=700');
        win.document.write('<html><head><title>Invoice - Bharat Darshan</title>');
        win.document.write('<style>');
        win.document.write(`
            body { font-family: 'Segoe UI', Arial, sans-serif; padding: 20px; color: #333; }
            .invoice-container { max-width: 800px; margin: 0 auto; border: 2px solid #FF6B35; border-radius: 8px; padding: 30px; }
            .invoice-header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #FF6B35; padding-bottom: 15px; margin-bottom: 20px; }
            .invoice-title { font-size: 28px; font-weight: bold; color: #FF6B35; }
            .invoice-subtitle { font-size: 12px; color: #666; }
            .section { margin-bottom: 20px; }
            .section-title { font-size: 14px; font-weight: bold; color: #FF6B35; margin-bottom: 8px; text-transform: uppercase; letter-spacing: 1px; }
            .info-row { display: flex; justify-content: space-between; margin-bottom: 4px; }
            .info-label { color: #666; font-size: 13px; }
            .info-value { font-weight: 600; font-size: 13px; }
            table { width: 100%; border-collapse: collapse; margin-top: 10px; }
            th { background-color: #FF6B35; color: white; padding: 10px; text-align: left; font-size: 13px; }
            td { padding: 10px; border-bottom: 1px solid #eee; font-size: 13px; }
            .total-section { margin-top: 15px; border-top: 2px solid #FF6B35; padding-top: 15px; }
            .total-row { display: flex; justify-content: space-between; margin-bottom: 6px; font-size: 14px; }
            .grand-total { font-size: 18px; font-weight: bold; color: #FF6B35; border-top: 1px solid #ccc; padding-top: 8px; margin-top: 8px; }
            .footer { text-align: center; margin-top: 30px; padding-top: 15px; border-top: 1px solid #eee; font-size: 11px; color: #999; }
            .gst-note { background: #FFF3E0; padding: 8px 12px; border-radius: 4px; font-size: 12px; color: #E65100; margin-top: 10px; }
            .no-gst-note { background: #E8F5E9; padding: 8px 12px; border-radius: 4px; font-size: 12px; color: #2E7D32; margin-top: 10px; }
            @media print { body { padding: 0; } .invoice-container { border: none; } }
        `);
        win.document.write('</style></head><body>');
        win.document.write(printContent.innerHTML);
        win.document.write('</body></html>');
        win.document.close();
        win.print();
    }

    const amount = parseFloat(data?.amount) || 0;
    const billType = data?.billType || data?.payee || '';
    const hasGST = isGSTApplicable(billType);
    
    // If GST applicable: baseAmount + 18% GST = totalAmount
    // The amount stored is what user actually paid
    let baseAmount, gstAmount, totalAmount;
    if (hasGST) {
        // User paid amount which includes GST, so: amount = base + 18% of base = base * 1.18
        baseAmount = parseFloat((amount / 1.18).toFixed(2));
        gstAmount = parseFloat((amount - baseAmount).toFixed(2));
        totalAmount = amount;
    } else {
        baseAmount = amount;
        gstAmount = 0;
        totalAmount = amount;
    }

    const formatDate = (dateStr) => {
        if (!dateStr) return 'N/A';
        return new Date(dateStr).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    };

    return (
        <div style={{ padding: '20px' }}>
            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', flexWrap: 'wrap' }}>
                <button onClick={handlePrintInvoice} style={{ padding: '10px 25px', backgroundColor: '#FF6B35', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>
                    🖨️ Print / Download Invoice
                </button>
                <button onClick={handleRefund} style={{ padding: '10px 25px', backgroundColor: '#d32f2f', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>
                    ↩️ Proceed to Refund
                </button>
            </div>

            {/* Invoice Preview */}
            <div ref={invoiceRef}>
                <div className="invoice-container" style={{ maxWidth: '800px', margin: '0 auto', border: '2px solid #FF6B35', borderRadius: '8px', padding: '30px', backgroundColor: '#fff' }}>
                    
                    {/* Header */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #FF6B35', paddingBottom: '15px', marginBottom: '20px' }}>
                        <div>
                            <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#FF6B35' }}>Bharat Darshan</div>
                            <div style={{ fontSize: '12px', color: '#666' }}>Navaratri Enterprises</div>
                            <div style={{ fontSize: '11px', color: '#999' }}>GSTIN: 05AATFN2979AIZ2</div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#333' }}>
                                {hasGST ? 'TAX INVOICE' : 'INVOICE'}
                            </div>
                            <div style={{ fontSize: '12px', color: '#666' }}>{formatDate(data?.createdAt || data?.updatedAt)}</div>
                        </div>
                    </div>

                    {/* Transaction Info */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                        <div>
                            <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#FF6B35', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>Transaction Details</div>
                            <div style={{ fontSize: '13px', marginBottom: '4px' }}><span style={{ color: '#666' }}>Order ID:</span> <strong>{data?.transactionalData?.razorpay_order_id || 'N/A'}</strong></div>
                            <div style={{ fontSize: '13px', marginBottom: '4px' }}><span style={{ color: '#666' }}>Transaction ID:</span> <strong>{data?.operatorData?.data?.ApiTransID || data?.transactionalData?.razorpay_payment_id || 'N/A'}</strong></div>
                            <div style={{ fontSize: '13px', marginBottom: '4px' }}><span style={{ color: '#666' }}>Status:</span> <strong style={{ color: data?.operatorData?.data?.Status === 'Success' || data?.transactionalData?.status_code === 200 ? '#2e7d32' : '#d32f2f' }}>{data?.operatorData?.data?.Status || (data?.transactionalData?.status_code === 200 ? 'Success' : 'Failed')}</strong></div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#FF6B35', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>Service Type</div>
                            <div style={{ fontSize: '16px', fontWeight: '700', color: '#333' }}>{billType || 'N/A'}</div>
                            {data?.refund && <div style={{ fontSize: '13px', color: '#d32f2f', marginTop: '4px' }}>Refund: {data?.refund}</div>}
                        </div>
                    </div>

                    {/* Billing Table */}
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                        <thead>
                            <tr>
                                <th style={{ backgroundColor: '#FF6B35', color: 'white', padding: '10px', textAlign: 'left', fontSize: '13px' }}>Description</th>
                                <th style={{ backgroundColor: '#FF6B35', color: 'white', padding: '10px', textAlign: 'right', fontSize: '13px' }}>Amount (₹)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ padding: '10px', borderBottom: '1px solid #eee', fontSize: '13px' }}>
                                    {billType || 'Service'} {data?.payee ? `- ${data.payee}` : ''}
                                </td>
                                <td style={{ padding: '10px', borderBottom: '1px solid #eee', fontSize: '13px', textAlign: 'right' }}>
                                    ₹{baseAmount.toFixed(2)}
                                </td>
                            </tr>
                            {hasGST && (
                                <>
                                    <tr>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #eee', fontSize: '13px', color: '#666' }}>
                                            CGST (9%)
                                        </td>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #eee', fontSize: '13px', textAlign: 'right', color: '#666' }}>
                                            ₹{(gstAmount / 2).toFixed(2)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #eee', fontSize: '13px', color: '#666' }}>
                                            SGST (9%)
                                        </td>
                                        <td style={{ padding: '10px', borderBottom: '1px solid #eee', fontSize: '13px', textAlign: 'right', color: '#666' }}>
                                            ₹{(gstAmount / 2).toFixed(2)}
                                        </td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </table>

                    {/* Total Section */}
                    <div style={{ marginTop: '15px', borderTop: '2px solid #FF6B35', paddingTop: '15px' }}>
                        {hasGST && (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '14px' }}>
                                    <span>Subtotal:</span>
                                    <span>₹{baseAmount.toFixed(2)}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '14px', color: '#666' }}>
                                    <span>GST (18%):</span>
                                    <span>₹{gstAmount.toFixed(2)}</span>
                                </div>
                            </>
                        )}
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '18px', fontWeight: 'bold', color: '#FF6B35', borderTop: hasGST ? '1px solid #ccc' : 'none', paddingTop: hasGST ? '8px' : '0', marginTop: hasGST ? '8px' : '0' }}>
                            <span>Total Amount Paid:</span>
                            <span>₹{totalAmount.toFixed(2)}</span>
                        </div>
                    </div>

                    {/* GST Note */}
                    {hasGST ? (
                        <div style={{ background: '#FFF3E0', padding: '8px 12px', borderRadius: '4px', fontSize: '12px', color: '#E65100', marginTop: '10px' }}>
                            * This invoice includes GST @18% (CGST 9% + SGST 9%) as applicable on {billType} services.
                        </div>
                    ) : (
                        <div style={{ background: '#E8F5E9', padding: '8px 12px', borderRadius: '4px', fontSize: '12px', color: '#2E7D32', marginTop: '10px' }}>
                            * GST is not applicable on {billType} service. The amount shown is the exact amount paid by the user.
                        </div>
                    )}

                    {/* Footer */}
                    <div style={{ textAlign: 'center', marginTop: '30px', paddingTop: '15px', borderTop: '1px solid #eee', fontSize: '11px', color: '#999' }}>
                        <p>If you have any concerns, please connect with our Customer Support via Website or Mobile Application.</p>
                        <p style={{ fontWeight: 'bold', marginTop: '5px' }}>Thank You for using Bharat Darshan!</p>
                        <p>Registered Address: Navaratri Enterprises | GSTIN: 05AATFN2979AIZ2</p>
                        <p>This is a computer-generated invoice. No signature required.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TransactionDetailsById
